
import React from 'react';
import ProductListServerPaginated from '@/components/ProductListServerPaginated';
import { ArrowUpRight } from 'lucide-react';
import EmptyState from '@/components/EmptyState';
import { Card, CardContent } from '@/components/ui/card';
import { useStripeConnection } from '@/hooks/useStripeConnection';
import { OnboardingBlocker } from '@/components/onboarding';

interface ProductsTabProps {
  stripeConnected: boolean;
  hasCreatedFirstProduct: boolean;
  filterStatus?: string;
  searchQuery?: string;
  productTypeFilter?: string;
  hasItems?: boolean;
}

const ProductsTab: React.FC<ProductsTabProps> = ({ 
  stripeConnected, 
  hasCreatedFirstProduct, 
  filterStatus = 'active',
  searchQuery = '',
  productTypeFilter = 'all',
  hasItems = false
}) => {
  // Convert the productTypeFilter value to a boolean flag for ProductList
  const includeSubscriptions = productTypeFilter !== 'one_time';
  const includeOneTime = productTypeFilter !== 'subscription';
  const { isLoading } = useStripeConnection();

  if (isLoading) {
    return (
      <Card className="border shadow-sm">
        <CardContent className="p-0">
          <div className="text-center py-12 bg-card">
            <p className="text-muted-foreground">Loading...</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <OnboardingBlocker requireStripe={true} requireBusinessProfile={true}>
      <ProductListServerPaginated 
        filterStatus={filterStatus} 
        searchQuery={searchQuery} 
        includeSubscriptions={includeSubscriptions}
        includeOneTime={includeOneTime}
      />
    </OnboardingBlocker>
  );
};

export default ProductsTab;
